module.exports = __webpack_public_path__ + "static/media/footer-logo-telstra-small.a6aa6cdf.svg";